module.exports = __webpack_public_path__ + "img/뱅가드.b2349a2b.png";